import appView from './appView.js';

class previewView extends appView {
  notesMarkup(data, options) {
    return `
          <div class="note-item all-notes ${data.tag} ${options.favorite}" data-id="${data.id}" data-favorited="${data.favorited}">
            <div class="note-inner-content">
              <div class="note-content">
                <p class="note-title" data-noteTitle="${data.title}">
                  ${options.limitTitle}
                </p>
                <p class="meta-time">
                 ${options.edited} ${options.newDate}
                </p>
                <div class="note-description-content">
                  <p class="note-description" data-noteDescription="${data.description}">
                    ${options.limitDescription}
                  </p>
                </div>
              </div>
              <div class="note-action">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-star fav-note">
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash-2 delete-note">
                  <polyline points="3 6 5 6 21 6"></polyline>
                  <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                  <line x1="10" y1="11" x2="10" y2="17"></line>
                  <line x1="14" y1="11" x2="14" y2="17"></line>
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit-2 edit-note"><path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path></svg>
              </div>
              <div class="note-footer">
                <div class="tags-selector btn-group">
                  <a class="nav-link dropdown-toggle d-icon label-group" data-bs-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="true">
                    <span>
                      <div class="tags">
                        <div class="g-dot-personal"></div>
                        <div class="g-dot-work"></div>
                        <div class="g-dot-social"></div>
                        <div class="g-dot-important"></div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-more-vertical">
                          <circle cx="12" cy="12" r="1"></circle>
                          <circle cx="12" cy="5" r="1"></circle>
                          <circle cx="12" cy="19" r="1"></circle>
                        </svg>
                      </div>
                    </span>
                  </a>
                  <div class="dropdown-menu dropdown-menu-right d-icon-menu">
                    <a class="note-personal label-group-item label-personal dropdown-item position-relative g-dot-personal" href="javascript:void(0);"> Personal</a>
                    <a class="note-work label-group-item label-work dropdown-item position-relative g-dot-work" href="javascript:void(0);"> Work</a>
                    <a class="note-social label-group-item label-social dropdown-item position-relative g-dot-social" href="javascript:void(0);"> Social</a>
                    <a class="note-important label-group-item label-important dropdown-item position-relative g-dot-important" href="javascript:void(0);"> Important</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        `;
  }

  todoMarkup(data, options) {
    return `
      <div class="todo-item ${data.trash ? '' : 'all-list'} ${
      options.important
    } ${options.completed} ${options.trash}" data-id="${
      data.id
    }" data-completed="${data.completed}" data-trash="${data.trash}"
      data-important="${data.important}" data-priority="${data.priority}">
        <div class="todo-item-inner">
          <div class="n-chk text-center">
            <div class="form-check form-check-primary form-check-inline mt-1 me-0" data-bs-toggle="collapse" data-bs-target="">
              <input class="form-check-input inbox-chkbox" type="checkbox" ${
                data.completed ? 'checked' : ''
              }>
            </div>
          </div>

          <div class="todo-content">
            <h5 class="todo-heading" data-todoheading="${data.title}">
             ${options.limitTitle}
            </h5>
            <p class="todo-text" data-todohtml="${
              data.description
            }" data-todotext="${data.description}">
              ${data.description}
            </p>
          </div>

          <div class="meta-frame">
            <p class="meta-time todo-time">${options.isCompleted} ${
      options.edited
    } ${options.newDate}</p>
          </div>

          <div class="priority-dropdown custom-dropdown-icon">
            <div class="dropdown p-dropdown">
              <a class="dropdown-toggle ${
                data.priority
              }" href="#" role="button" id="dropdownMenuLink-1" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-alert-octagon">
                  <polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon>
                  <line x1="12" y1="8" x2="12" y2="12"></line>
                  <line x1="12" y1="16" x2="12" y2="16"></line>
                </svg>
              </a>

              <div class="dropdown-menu left" aria-labelledby="dropdownMenuLink-1">
                <a class="danger dropdown-item p-label-group" href="javascript:void(0);"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-alert-octagon">
                    <polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon>
                    <line x1="12" y1="8" x2="12" y2="12"></line>
                    <line x1="12" y1="16" x2="12" y2="16"></line>
                  </svg>
                  High</a>
                <a class="warning dropdown-item p-label-group" href="javascript:void(0);"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-alert-octagon">
                    <polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon>
                    <line x1="12" y1="8" x2="12" y2="12"></line>
                    <line x1="12" y1="16" x2="12" y2="16"></line>
                  </svg>
                  Middle</a>
                <a class="primary dropdown-item p-label-group" href="javascript:void(0);"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-alert-octagon">
                    <polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon>
                    <line x1="12" y1="8" x2="12" y2="12"></line>
                    <line x1="12" y1="16" x2="12" y2="16"></line>
                  </svg>
                  Low</a>
              </div>
            </div>
          </div>

          <div class="action-dropdown custom-dropdown-icon">
            <div class="dropdown">
              <a class="dropdown-toggle" href="#" role="button" id="dropdownMenuLink-2" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-more-vertical">
                  <circle cx="12" cy="12" r="1"></circle>
                  <circle cx="12" cy="5" r="1"></circle>
                  <circle cx="12" cy="19" r="1"></circle>
                </svg>
              </a>

              <div class="dropdown-menu left" aria-labelledby="dropdownMenuLink-2">
                <a class="edit dropdown-item" href="javascript:void(0);">Edit</a>
                <a class="important dropdown-item" href="javascript:void(0);">${
                  data.important === 1 ? 'Mark as Normal' : 'Mark as Important'
                }</a>
                <a class="dropdown-item delete" href="javascript:void(0);">Delete</a>
                <a class="dropdown-item permanent-delete" href="javascript:void(0);">Permanent Delete</a>
                <a class="dropdown-item revive" href="javascript:void(0);">Revive Task</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  scrumBoardMarkup(data) {
    return `
        <div data-draggable="true" data-list-id="${
          data.tasksection
        }" data-card-id="${data.id}" data-order="${
      data.order
    }" class="card task-text-progress" style="">
          <div class="card-body">
            <div class="task-header">
              <div>
                <h4 class="" data-taskTitle="${data.title}">${data.title}</h4>
              </div>
              <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit-2 s-task-edit">
                  <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
                </svg>
              </div>
            </div>
            <div class="task-body">
              <div class="task-content">
                <p class="" data-taskText="${data.description}">${
      data.description
    }</p>
                <div class="${data.progress ? '' : 'progress-none-bar d-none'}">
                    <div class="progress br-30">
                      <div class="progress-bar bg-success" role="progressbar" data-progressstate="${
                        data.progress
                      }" style="width: ${data.progress}%" aria-valuenow="${
      data.progress
    }" aria-valuemin="0" aria-valuemax="100">
                      </div>
                    </div>
                    <p class="progress-count">${data.progress}%</p>
                </div>
              </div>
              <div class="task-bottom">
                <div class="tb-section-1">
                  <span data-taskDate="${data.date}">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-calendar">
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                      <line x1="16" y1="2" x2="16" y2="6"></line>
                      <line x1="8" y1="2" x2="8" y2="6"></line>
                      <line x1="3" y1="10" x2="21" y2="10"></line>
                    </svg>
                    ${data.date}
                  </span>
                </div>
                <div class="tb-section-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash-2 s-task-delete">
                    <polyline points="3 6 5 6 21 6"></polyline>
                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                    <line x1="10" y1="11" x2="10" y2="17"></line>
                    <line x1="14" y1="11" x2="14" y2="17"></line>
                  </svg>
                </div>
              </div>
            </div>
          </div>`;
  }

  scrumListMarkup(data) {
    return `
    <div data-section="${data.id}" data-order="${data.order}" class="task-list-container mb-4 " data-connect="sorting">
      <div class="connect-sorting">
        <div class="task-container-header">
          <h6 class="s-heading" data-listTitle="${data.title}">
            ${data.title}
          </h6>
          <div class="dropdown">
            <a class="dropdown-toggle" href="#" role="button" id="dropdownMenuLink-4" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-more-horizontal">
                <circle cx="12" cy="12" r="1"></circle>
                <circle cx="19" cy="12" r="1"></circle>
                <circle cx="5" cy="12" r="1"></circle>
              </svg>
            </a>
            <div class="dropdown-menu dropdown-menu-right left" aria-labelledby="dropdownMenuLink-4">
              <a class="dropdown-item list-edit" href="javascript:void(0);">Edit List</a>
              <a class="dropdown-item list-delete" href="javascript:void(0);">Delete List</a>
              <a class="dropdown-item list-clear-all" href="javascript:void(0);">Clear All Cards</a>
            </div>
          </div>
        </div>
        <div class="connect-sorting-content" data-sortable="true">
        </div>
        <div class="add-s-task">
          <a class="addTask">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus-circle">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="16"></line>
              <line x1="8" y1="12" x2="16" y2="12"></line>
            </svg>
            Add Task
          </a>
        </div>
      </div>
    </div>
  `;
  }

  timeLineMarkup(data, timeFormat) {
    return `
          <div class="item-timeline">
            <p class="t-time">${timeFormat.timeDigits}</p>
            <div class="t-dot t-dot-${data.tag}"></div>
            <div class="t-text">
              <p>${data.title}</p>
              <p class="t-meta-time">${timeFormat.timeAgo}</p>
              ${
                data.startdate
                  ? `<p class="t-meta-time event-time"> ${data.startdate}</p>`
                  : ''
              }
            </div>
          </div>
    `;
  }
}

export default new previewView();
